import { render, staticRenderFns } from "./detalhe_compra_cliente.vue?vue&type=template&id=76b066df&scoped=true&"
import script from "./detalhe_compra_cliente.vue?vue&type=script&lang=js&"
export * from "./detalhe_compra_cliente.vue?vue&type=script&lang=js&"
import style0 from "./detalhe_compra_cliente.vue?vue&type=style&index=0&id=76b066df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b066df",
  null
  
)

export default component.exports